import React from "react";
import { classNames } from "primereact/utils";
import { MenuModel } from "../../types";
import { getMenuChildren } from "../../utils/menuNavigation";
import { useSidebar } from "../../contexts/SidebarContext";
import AppSidebarItem from "./AppSidebarItem";

type AppSidebarSectionProps = {
    section: MenuModel;
    sectionIndex: number;
    activeMenuKey: string | null;
};

const AppSidebarSection = ({
    section,
    sectionIndex,
    activeMenuKey,
}: AppSidebarSectionProps) => {
    const { isMini } = useSidebar();
    const items = getMenuChildren(section);

    if (!items.length) {
        return null;
    }

    return (
        <div
            className={classNames("app-sidebar-section", {
                "app-sidebar-section--mini": isMini,
            })}
        >
            <div
                className="app-sidebar-section__title"
                aria-hidden={isMini}
            >
                {section.label}
            </div>

            {isMini && (
                <div className="app-sidebar-section__marker" aria-hidden="true">
                    <span />
                    <span />
                    <span />
                </div>
            )}

            <ul className="app-sidebar-section__items">
                {items.map((item, index) => (
                    <AppSidebarItem
                        key={item.key ?? `${sectionIndex}-${index}`}
                        item={item}
                        itemKey={`${sectionIndex}-${index}`}
                        activeMenuKey={activeMenuKey}
                        sectionLabel={section.label}
                    />
                ))}
            </ul>
        </div>
    );
};

export default AppSidebarSection;
